import { PlusOutlined } from '@ant-design/icons';
import RenderIf from '@common/RenderIf';

import { TSidePanelOption } from '../common/types';

import css from '../sidePanelSelect.module.scss';

type Props = {
    options: TSidePanelOption[];
    value?: number;
    searchValue: string;
    onSelect: (option: TSidePanelOption) => void;
    onCreateOption?: (label: string) => void;
    style: React.CSSProperties;
};

/**
 * Панель вариантов: список плюс кнопка «завести своё значение».
 *
 * Кнопку показываем, только когда поиск ничего не нашёл — предлагать создать
 * то, что уже есть в списке, значит плодить дубликаты характеристик.
 */
export const OptionsPanel: React.FC<Props> = ({
    options,
    value,
    searchValue,
    onSelect,
    onCreateOption,
    style,
}) => {
    const trimmedSearch = searchValue.trim();
    const canCreate = !!onCreateOption && !options.length && !!trimmedSearch;

    return (
        <div className={css.panel} style={style} role="listbox">
            <RenderIf condition={!options.length && !canCreate}>
                <div className={css.empty}>Ничего не нашлось</div>
            </RenderIf>

            {options.map((option) => (
                <div
                    key={option.value}
                    role="option"
                    aria-selected={option.value === value}
                    className={`${css.option} ${option.value === value ? css.optionSelected : ''}`}
                    // mousedown, а не click: click прилетает уже после blur поля,
                    // и к этому моменту владелец успевает закрыть панель
                    onMouseDown={(event) => {
                        event.preventDefault();
                        onSelect(option);
                    }}
                >
                    {option.label}
                </div>
            ))}

            <RenderIf condition={canCreate}>
                <button
                    type="button"
                    className={css.create}
                    onMouseDown={(event) => {
                        event.preventDefault();
                        onCreateOption?.(trimmedSearch);
                    }}
                >
                    <PlusOutlined />
                    &nbsp;&quot;{trimmedSearch}&quot;
                </button>
            </RenderIf>
        </div>
    );
};
